import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';

import Loader from '../../../components/Common/Loader/Loader';
import FooterSettingsForm from '../../../components/SiteAdmin/FooterSettingsForm/FooterSettingsForm'

import getAllHomePageSettings from './getAllHomePageSettings.graphql';
import { withQuery } from '../../../hoc/withGraphql';


export class FooterSettings extends Component {
    static propTypes = {
        id: PropTypes.number.isRequired
    }
    static defaultProps = {
        data: {
            loading: true
        }
    }
    render() {
        const { data: { loading, getAllHomePageSettings } } = this.props;
        let initialValues = {};
        let homepageCollection = {};

        getAllHomePageSettings && getAllHomePageSettings.homePageData.map((item) => {
            if (item?.dynamicHomePageSettings && item?.dynamicHomePageSettings?.length > 0) {
                homepageCollection[item?.name] = item?.dynamicHomePageSettings.map(data => ({
                    value: data?.value,
                    language: data?.language,
                    contentId: data?.contentId,
                    description: data?.description,
                    urlTitle: data?.urlTitle
                }))
            } else {
                homepageCollection[item.name] = item.value
            }
        })

        return (
            <Loader type={"page"} show={loading}>
                {!loading && <FooterSettingsForm initialValues={homepageCollection} />}
            </Loader>
        )
    }
}

export default compose(withQuery(getAllHomePageSettings, {
    options: (props) => ({
        variables: {
            id: props.id
        },
        fetchPolicy: 'network-only',
        ssr: false
    })
}))(FooterSettings)
